<template>
  <div class="box">
    <div class="container">
      <div class="head"><img src="../assets/banner.jpg" /></div>
      <div class="indexPage indexBG">
        <div class="intro">
          <p>
            <span class="fontB fontS18">编者按：</span
            >疫情就是命令，防控就是责任。在这场没有硝烟的战役中，山西医科大学坚决贯彻落实党中央、国务院对疫情防控工作的统一部署，始终把师生医护员工身体健康和生命安全摆在首位。
          </p>
          <p>
            鉴于目前疫情尚未结束，形势依然严峻，防控仍处于进行时，为提高广大师生对疫情防控的理性认识和科学应对，提前做好2020年春季学期开学相关准备工作，山西医科大学新冠肺炎疫情防控工作领导小组紧急组织编写了《高校开学防疫攻略》一书，全书内容分为“师生开学返校攻略”“在校学习生活攻略”“教师在校
            工作攻略”三部分共十二章，以电子书的形式供所有高校师生使用。
          </p>
        </div>
        <div class="author">
          <div class="line">
            <div class="authorL ws">
              主 审
            </div>
            <ul class="authorR">
              <li>徐建国</li>
            </ul>
          </div>
          <div class="line">
            <div class="authorL">总指导</div>
            <ul class="authorR">
              <li>山西省教育厅</li>
            </ul>
          </div>
          <div class="line">
            <div class="authorL ws">主 编</div>
            <ul class="authorRname">
              <li>张俊龙</li>
              <li>李思进</li>
            </ul>
          </div>
          <div class="authorL">副主编</div>
          <ul class="authorRname">
            <li>贺培凤</li>
            <li>党志峰</li>
            <li>王宏伟</li>
            <li class="ws">解 军</li>
            <li class="ws">张 辉</li>
            <li>刁海鹏</li>
          </ul>
        </div>
        <div class="joinBtn">
          <router-link to="/menu">
            <button v-track-event="'category, action'">点击阅读</button>
          </router-link>
        </div>
        <div class="staff">
          <ul class="staffL">
            <li>
              <strong>编委：（按姓氏笔画排序）</strong>
            </li>
          </ul>
          <ul class="staffA">
            <li class="ws">王 彤</li>
            <li>王志栋</li>
            <li>王素萍</li>
            <li>王晓晖</li>
            <li>王崇刚</li>
            <li class="ws">牛 琪</li>
            <li>毛红胜</li>
            <li class="ws">石 璟</li>
            <li>田新瑞</li>
            <li>成晓龙</li>
            <li>刘佳佳</li>
            <li>李建强</li>
            <li>宋修珍</li>
            <li class="ws">张 巍</li>
            <li>张宇斌</li>
            <li>张岩波</li>
            <li>张新日</li>
            <li>张缭云</li>
            <li>赵文军</li>
            <li>侯小宝</li>
            <li>施熠炜</li>
            <li>郭亚斌</li>
            <li>曹小清</li>
            <li>樊清华</li>
          </ul>
          <ul class="staffL">
            <li>
              <strong>策划编辑：</strong><span>吴雪梅</span><span>瞿德竑 </span
              ><span class="ws">杨 兵</span>
            </li>
          </ul>
          <ul class="staffL">
            <li>
              <strong>责任编辑：</strong><span>瞿德竑</span
              ><span class="ws">杨 兵</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>高等教育出版社 版权所有 京ICP备12020869号-1</div>
      <div>
        京ICP证150856号
        <img src="../assets/2020-gongan.png" /> 京公网安备11010202008535号
      </div>
    </div>

    <WxShare></WxShare>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.head {
  width: 100%;
  line-height: 0;
}

.head img {
  width: 100%;
}

.indexBG {
  background: url(../assets/bg.jpg) repeat-x;
  margin-top: -0.5rem;
  padding: 0 2rem 2rem 2rem;
}

.intro {
  background: #179675;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0.2rem 0.2rem 0.8rem #097055;
  color: #fff;
  text-align: justify;
}

.intro p {
  text-indent: 2em;
}

.author {
  overflow: hidden;
  margin: 2rem 0;
}

.authorL {
  float: left;
  width: 30%;
  color: #fff;
  background: #097055;
  border-radius: 5rem;
  text-align: center;
}

.authorR {
  float: left;
  width: 70%;
  list-style: none;
  color: #fff;
}

.authorR li {
  padding-left: 2rem;
}

.authorRname {
  overflow: hidden;
  float: left;
  width: 70%;
  list-style: none;
  color: #fff;
}

.authorRname li {
  padding-left: 2rem;
  float: left;
  width: 8.5rem;
}

.authorR li span {
  padding-left: 1rem;
  color: #feff88;
  font-size: 1.4rem;
}

.joinBtn button {
  background: #fff;
  padding: 1rem 0;
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
  color: #097055;
  width: 100%;
  border-radius: 0.5rem;
  border: 0.2rem solid #097055;
  box-shadow: 0.1rem 0.1rem 0.5rem #097055;
  cursor: pointer;
}

.staff {
  overflow: hidden;
  color: #fff;
  font-size: 1.2rem;
  margin-left: -1rem;
  margin-right: -1rem;
  line-height: 2.4rem;
  margin-top: 2rem;
}

.staffA {
  display: block;
  clear: both;
  overflow: hidden;
  padding-left: 1rem;
}

.staffA li {
  float: left;
  width: 6.2rem;
  padding-right: 1rem;
}

.staffL {
  width: 100%;
  list-style: none;
  padding-left: 1rem;
  padding-right: 1rem;
}

.staffL span {
  margin-right: 1.5rem;
}

.staffR {
  width: 46%;
  float: left;
  list-style: none;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
